export function format(translation, ...args) {
	for (let i = 0; i < args.length; i++) {
		translation = translation.replace(new RegExp('\\{' + i + '}', 'g'), args[i]);
	}

	return translation;
};
